import service from '../providers/service.js';
import {
  SET_PROJECTS,
  UNSET_PROJECT,
  SET_SELECTED_PROJECT,
  UNSET_SELECTED_PROJECT
} from './types.js';
import { tokenize } from "../helpers/token.js";
import BrowserHistory from "../providers/BrowserHistory.js";
import { setErrors } from "./error.js";
// import { setSelectedDonor } from "./donor.js";
import { setAsset } from "./asset.js";
import { setAttachment } from "./attachment.js";

// Fetch all projects
export function fetchProjects() {
  return (dispatch) => {
    service
      .get(tokenize('/api/projects'))
      .then(response => {
        // Save projects to redux store
        dispatch(setProjects(response.data.projects));
        // dispatch(setPermissions(response.data.permissions));
      }).catch((err) => {
        console.log(err);
      })
  }
}

// Fetch project by id
export function fetchProject(projectId) {
  return (dispatch) => {
    service
      .get(tokenize(`/api/projects/${projectId}`))
      .then(response => {
        // Save projects to redux store
        dispatch(setSelectedProject(response.data.project));

        // Set selected donors to state
        // if (response.data.project.donors) {
        //   response.data.project.donors.forEach(d => dispatch(setSelectedDonor(d.id)));
        // }

        // Set assets to state
        if (response.data.project.assets) {
          response.data.project.assets.forEach(a => dispatch(setAsset(a)));
        }

        // Set attachments to state
        if (response.data.project.attachments) {
          response.data.project.attachments.forEach(a => dispatch(setAttachment(a)));
        }
      }).catch((err) => {
        console.log(err);
      })
  }
}

// Create new project
export function createProject(project) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(project).forEach(k => {
      if (project[k]) {
        if (project[k].constructor === Array) {
          data.append(k, JSON.stringify(project[k]));
        } else {
          data.append(k, project[k]);
        }
      }
    });

    console.log(project);

    service
      .post(tokenize(`/api/projects`), data, config)
      .then(response => {
        if (response.data.message === 'project.success') {
          BrowserHistory.push('/main/projects');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}


// Update project
export function updateProject(project) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(project).forEach(k => {
      if (project[k]) {
        if (project[k].constructor === Array) {
          data.append(k, JSON.stringify(project[k]));
        } else {
          data.append(k, project[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/projects/${project.id}`), data, config)
      .then(response => {
        if (response.data.message === 'project.success') {
          BrowserHistory.push('/main/projects');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Delete project
export function deleteProject(projectId) {
  return dispatch => {
    service
      .post(tokenize(`/api/projects/${projectId}/destroy`))
      .then(response => {
        if (response.data.message === 'project.success') {
          dispatch(unsetProject(projectId))
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Save projects to redux store
export function setProjects(projects) {
  return {
    type: SET_PROJECTS,
    projects: projects
  };
}

// Save selected project to store
export function setSelectedProject(project) {
  return {
    type: SET_SELECTED_PROJECT,
    project: project
  };
}

// Unset selected project from store to avoid render anomalies on edit page
export function unsetSelectedProject() {
  return { type: UNSET_SELECTED_PROJECT };
}

// Delete project from store
export function unsetProject(project) {
  return {
    type: UNSET_PROJECT,
    project: project
  };
}


// WEBPACK FOOTER //
// ./src/actions/project.js